


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const BASE_URL = "https://ecom.cyberathon.com";
// const API_URL = BASE_URL + "/index.php/Api/get_list_card_sections";

// const HomeOffers = () => {
//   const [offers, setOffers] = useState([]);
//   const [loading, setLoading] = useState(true);
// const navigate = useNavigate();

//   useEffect(() => {
//     const fetchOffers = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         setOffers(res.data.data || []);
//       } catch (error) {
//         console.error("Error fetching offers", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchOffers();
//   }, []);

//   if (loading) {
//     return (
//       <div className="container py-5 text-center">
//         <h5>Loading offers...</h5>
//       </div>
//     );
//   }

//   if (offers.length === 0) {
//     return (
//       <div className="container py-5 text-center">
//         <h5>No offers available</h5>
//       </div>
//     );
//   }


//   return (
//     <div className="container-fluid px-md-5 py-md-3">
//       <div className="row g-4">

//         {/* LEFT BIG CARD */}
//         {offers[0] && (
//           <div className="col-12 col-lg-6">
//             <div className="p-3 rounded-3 shadow-sm h-100 bg-primary-subtle d-flex flex-column flex-md-row align-items-center overflow-hidden"
//             // onClick={() => navigate(`/offer/${offers[0].id}`)}
//             // onClick={() => navigate(`/DetailsSection3/${offers[0].prod_id}`)}
//             onClick={() => navigate(`/products?discount=${offers[0].discount}`)}
//             >
//               <div className="flex-grow-1">
//                 <span className="badge bgbtncolor mb-2">
//                   {offers[0].discount} OFF
//                 </span>

//                 <h4 className="fw-bold">{offers[0].title}</h4>

//                 <h5  style={{ textAlign: "justify" }} className="pe-4">{offers[0].description}</h5>

//                 <p className="text-muted text-decoration-line-through">
//                   ₹{offers[0].old_price}
//                 </p>

//                 <h5 className="fw-bold">
//                   ₹{offers[0].current_price}
//                   {/* <small className="text-muted"> Including Tax</small> */}
//                    <small className="text-muted"></small>
//                 </h5>
//               </div>

//               <img
//                 src={`${BASE_URL}/${offers[0].image}`}
//                 alt={offers[0].title}
//                 className="img-fluid imgsize"
//               />
//             </div>
//           </div>
//         )}

//         {/* RIGHT SIDE */}
//         <div className="col-12 col-lg-6">
//           <div className="row g-4">

//             {/* RIGHT TOP CARD */}
//             {offers[1] && (
//               <div className="col-12">
//                 <div className="p-4 rounded-3 shadow-sm h-100 bg-danger-subtle d-flex justify-content-between align-items-center"
//                 //  onClick={() => navigate(`/offer/${offers[1].id}`)}
//                 //  onClick={() => navigate(`/DetailsSection3/${offers[1].prod_id}`)}
//                onClick={() => navigate(`/products?discount=${offers[1].discount}`)}
//                  >
//                   <div>
//                     <span className="badge bgbtncolor mb-2">
//                       {offers[1].discount} OFF
//                     </span>

//                     <h5>{offers[1].title}</h5>

//                     <p className="text-muted text-decoration-line-through">
//                       ₹{offers[1].old_price}
//                     </p>

//                     <h6 className="fw-bold">
//                       ₹{offers[1].current_price}
//                       {/* <small className="text-muted"> Including Tax</small> */}
//                         <small className="text-muted"></small>
//                     </h6>
//                   </div>

//                   <img
//                     src={`${BASE_URL}/${offers[1].image}`}
//                     alt={offers[1].title}
//                     className="img-fluid hair_size"
//                   />
//                 </div>
//               </div>
//             )}

//             {/* RIGHT BOTTOM CARD */}
//             {offers[2] && (
//               <div className="col-12">
//                 <div className="p-4 rounded-3 shadow-sm h-100 bg-info-subtle d-flex justify-content-between align-items-center"
//                 //  onClick={() => navigate(`/offer/${offers[2].id}`)}
//                 // onClick={() => navigate(`/DetailsSection3/${offers[2].prod_id}`)}
//                 onClick={() => navigate(`/products?discount=${offers[2].discount}`)}
//                  >
//                   <div>
//                     <span className="badge bgbtncolor mb-2">
//                       {offers[2].discount} OFF
//                     </span>

//                     <h5>{offers[2].title}</h5>

//                     <p className="text-muted text-decoration-line-through">
//                       ₹{offers[2].old_price}
//                     </p>

//                     <h6 className="fw-bold">
//                       ₹{offers[2].current_price}
//                       {/* <small className="text-muted"> Including Tax</small> */}
//                         <small className="text-muted"></small>
//                     </h6>
//                   </div>

//                   <img
//                     src={`${BASE_URL}/${offers[2].image}`}
//                     alt={offers[2].title}
//                     className="img-fluid hair_size"
//                   />
//                 </div>
//               </div>
//             )}

//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default HomeOffers;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://ecom.cyberathon.com";
const OFFERS_API = BASE_URL + "/index.php/Api/get_list_card_sections";
const PRODUCT_API = BASE_URL + "/index.php/Api/get_by_id_create_product";

const fetchProductById = async (prod_id) => {
  try {
    const res = await axios.post(PRODUCT_API, { prod_id: Number(prod_id) });
    if (res.data.status && res.data.products?.length > 0) {
      return res.data.products[0];
    }
  } catch (e) {
    console.error("Product fetch error", e);
  }
  return null;
};

const buildCard = (offer, product) => ({
  id: offer.id,
  discount: offer.discount,
  // All prod_ids from this card section (used for filtering on products page)
  allProdIds: (offer.items || []).map((i) => String(i.prod_id)),
  prod_id: product?.prod_id,
  name: product?.Product_name || "—",
  image: product?.Product_image?.[0]
    ? `${BASE_URL}/${product.Product_image[0]}`
    : null,
  current_price: product?.current_price || "—",
  old_price: product?.old_price || "—",
  description: product?.discription || product?.large_description || "",
});

const isValidPrice = (price) => {
  return price && Number(price) > 0;
};

const HomeOffers = () => {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(OFFERS_API);
        const offers = res.data.data || [];
        const enriched = await Promise.all(
          offers.slice(0, 3).map(async (offer) => {
            const firstProdId = offer.items?.[0]?.prod_id;
            const product = firstProdId ? await fetchProductById(firstProdId) : null;
            return buildCard(offer, product);
          })
        );
        setCards(enriched);
      } catch (err) {
        console.error("HomeOffers load error", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // Pass discount + all prod_ids of this card section to products page
  const handleCardClick = (card) => {
    navigate("/products", {
      state: {
        offerDiscount: card.discount,
        // offerProdIds: card.allProdIds,   // array of prod_ids in this offer
        offerLabel: `${card.discount}% Off — Special Offer`,
      },
    });
  };

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status" />
        <p className="mt-2 text-muted">Loading offers...</p>
      </div>
    );
  }

  if (cards.length === 0) {
    return (
      <div className="container py-5 text-center">
        <h5>No offers available</h5>
      </div>
    );
  }

  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const [card0, card1, card2] = cards;

  return (
    <div className="container-fluid px-md-5 py-md-3">
      <div className="row g-4">

        {/* ══ LEFT BIG CARD ══ */}
        {card0 && (
          <div className="col-12 col-lg-6">
            <div
              className="p-3 rounded-3 shadow-sm h-100 bg-primary-subtle d-flex flex-column flex-md-row align-items-center overflow-hidden"
              style={{ cursor: "pointer" }}
              onClick={() => handleCardClick(card0)}
            >
              <div className="flex-grow-1 pe-md-3">
                <span className="badge bgbtncolor mb-2">{card0.discount}% OFF</span>
                <h4 className="fw-bold">{card0.name}</h4>
                <p
                  className="text-muted"
                  style={{
                    textAlign: "justify",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {stripHtml(card0.description)}
                </p>
                {/* <p className="text-muted text-decoration-line-through mb-0">₹{card0.old_price}</p> */}
                {isValidPrice(card0.old_price) && (
  <p className="text-muted text-decoration-line-through mb-0">
    ₹{card0.old_price}
  </p>
)}
                {/* <h5 className="fw-bold">₹{card0.current_price}</h5> */}
                {isValidPrice(card0.current_price) && (
  <h5 className="fw-bold">
    ₹{card0.current_price}
  </h5>
)}
              </div>
              {card0.image && (
                <img src={card0.image} alt={card0.name} className="img-fluid imgsize"
                  style={{ maxHeight: "180px", objectFit: "contain" }} />
              )}
            </div>
          </div>
        )}

        {/* ══ RIGHT SIDE ══ */}
        <div className="col-12 col-lg-6">
          <div className="row g-4">

            {card1 && (
              <div className="col-12">
                <div
                  className="p-4 rounded-3 shadow-sm h-100 bg-danger-subtle d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCardClick(card1)}
                >
                  <div className="flex-grow-1 pe-3">
                    <span className="badge bgbtncolor mb-2">{card1.discount}% OFF</span>
                    <h5 className="fw-semibold"
                      style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                      {card1.name}
                    </h5>
                    {/* <p className="text-muted text-decoration-line-through mb-0">₹{card1.old_price}</p>
                    <h6 className="fw-bold">₹{card1.current_price}</h6> */}
                    {isValidPrice(card1.old_price) && (
  <p className="text-muted text-decoration-line-through mb-0">
    ₹{card1.old_price}
  </p>
)}

{isValidPrice(card1.current_price) && (
  <h6 className="fw-bold">
    ₹{card1.current_price}
  </h6>
)}
                  </div>
                  {card1.image && (
                    <img src={card1.image} alt={card1.name} className="img-fluid hair_size"
                      style={{ maxHeight: "120px", objectFit: "contain" }} />
                  )}
                </div>
              </div>
            )}

            {card2 && (
              <div className="col-12">
                <div
                  className="p-4 rounded-3 shadow-sm h-100 bg-info-subtle d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCardClick(card2)}
                >
                  <div className="flex-grow-1 pe-3">
                    <span className="badge bgbtncolor mb-2">{card2.discount}% OFF</span>
                    <h5 className="fw-semibold"
                      style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                      {card2.name}
                    </h5>
                    {/* <p className="text-muted text-decoration-line-through mb-0">₹{card2.old_price}</p>
                    <h6 className="fw-bold">₹{card2.current_price}</h6> */}
                    {isValidPrice(card1.old_price) && (
  <p className="text-muted text-decoration-line-through mb-0">
    ₹{card1.old_price}
  </p>
)}

{isValidPrice(card1.current_price) && (
  <h6 className="fw-bold">
    ₹{card1.current_price}
  </h6>
)}
                  </div>
                  {card2.image && (
                    <img src={card2.image} alt={card2.name} className="img-fluid hair_size"
                      style={{ maxHeight: "120px", objectFit: "contain" }} />
                  )}
                </div>
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
  );
};

export default HomeOffers;